import { dayjs as _dayjs } from '../../utils';
import shoplineZhHant from '../../utils/shopline-locale-zh-hant';
import shoplineZhCn from '../../utils/shopline-locale-zh-cn';
import shoplineEn from '../../utils/shopline-locale-en';
import shoplineVi from '../../utils/shopline-locale-vi';
import shoplineTh from '../../utils/shopline-locale-th';
import customLocales from './locales';
const dayJSLocaleMap = {
    en: Object.assign({}, shoplineEn, customLocales.en),
    'zh-hant': Object.assign({}, shoplineZhHant, customLocales['zh-hant']),
    'zh-cn': Object.assign({}, shoplineZhCn, customLocales['zh-cn']),
    vi: Object.assign({}, shoplineVi, customLocales.vi),
    th: Object.assign({}, shoplineTh, customLocales.th),
};
export default (locale, date, format) => _dayjs(date, format).locale(dayJSLocaleMap[locale]);
//# sourceMappingURL=day.js.map